import React from "react";
import { MessageCircle } from "lucide-react";
import { TID } from "../lib/testIds";

const PHONE = "+41774069813";
const WHATSAPP_URL = `https://wa.me/${PHONE.replace(/[^0-9]/g, "")}?text=${encodeURIComponent("Bom dia, gostaria de reservar um transfer com a SwissAlpenLine.")}`;

export const FloatingWhatsApp = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noreferrer"
      data-testid={TID.whatsappFloat}
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full flex items-center justify-center border border-brand-platinum bg-brand-bg/90 backdrop-blur-md shadow-[0_0_25px_rgba(232,228,218,0.08)] transition-transform duration-300 hover:scale-110"
    >
      <MessageCircle size={22} className="text-brand-platinum" />
      <span className="absolute inset-0 rounded-full border border-brand-platinum animate-pulseSoft pointer-events-none" />
    </a>
  );
};

export default FloatingWhatsApp;
